class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));
    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
    this._exitHandler = this._onExitIntent.bind(this);
    this._mobileScrollHandler = this._onMobileScroll.bind(this);
    this._fallbackTimer = null;
    this._lastScrollY = window.scrollY;
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true", 30);
    this._removeExitListeners();
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") this.show();
      return;
    }
    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this._attachExitListeners();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");
    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;
      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");
      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) this._attachExitListeners();
      }
    });
    observer.observe(this, { attributes: true });
  }

  _attachExitListeners() {
    if (this.closed === "true" || this.subscribed === "true") return;

    document.addEventListener("mouseleave", this._exitHandler);
    window.addEventListener("scroll", this._mobileScrollHandler, { passive: true });

    this._fallbackTimer = setTimeout(() => {
      this._removeExitListeners();
      this.show();
    }, 90 * 1000);
  }

  _removeExitListeners() {
    document.removeEventListener("mouseleave", this._exitHandler);
    window.removeEventListener("scroll", this._mobileScrollHandler);
    clearTimeout(this._fallbackTimer);
  }

  _onExitIntent(e) {
    if (e.clientY > 20) return;
    this._removeExitListeners();
    this.show();
  }

  _onMobileScroll() {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 300 && currentScrollY < this._lastScrollY - 50) {
      this._removeExitListeners();
      this.show();
    }
    this._lastScrollY = currentScrollY;
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true", 365);
    this._removeExitListeners();
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);